export const renderListItems = (listKey, t) =>
  t(listKey)
    .split('|')
    .map((item) => item.trim())
    .filter(Boolean);
